import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper} from 'material-ui';
import Error from "../../common/Error/Error";
import Trail from '../Trail/Trail';
import style from '../../../styles/styles';

const TrailList = (props) => {
    const { trails, title, user, app } = props;

    let content;

    if (trails.length === 0) {
        content =
            <Error
                title="No data"
                subtitle="Add some trails"
            />
    }  else {
        content = trails.map(function(trail, index) {
            return <div key={trail.id}>
                <Trail
                    app={app}
                    user={user}
                    trail={trail}
                    handleRemoveTrail={props.handleRemoveTrail}
                />
                {index !== (trails.length - 1) &&  <Divider inset={true}/>}
            </div>
        })
    }

    return (
        <Paper>
            <List>
                <Subheader style={style.subHeader}>{title}</Subheader>
                {content}
            </List>
        </Paper>
    );
};

TrailList.propTypes = {
    trails: PropTypes.arrayOf(PropTypes.object).isRequired,
    user: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    title: PropTypes.string,
    handleRemoveTrail: PropTypes.func
};

export default TrailList;



// WEBPACK FOOTER //
// src/components/openexplore/TrailList/TrailList.js